// Ensure comet styles are injected into the page first
import 'normalize.css/normalize.css';
import '@discoveryedu/nebula-core/dist/styles/fonts/proxima_nova.css';
import '@discoveryedu/nebula-core/dist/styles/fonts/proxima_vara.css';
import '@discoveryedu/nebula-core/dist/styles/fonts/mikado_chan.css';
import '@discoveryedu/comet-components/comet.css';
import '@discoveryedu/nebula-core/dist/styles/nebula_core.css';
import '@discoveryedu/nebula-components/dist/nebula-components-assets/main-lib.css';
import '@discoveryedu/mystery-components/dist/main-lib.css';

import '@/lib/errorPolyfill';
import initialize from './initialize';
import {
  createApiClients,
  getDomains,
  getRegion,
  getEnv,
  addRateLimiting,
} from './lib/api';

async function run() {
  const {
    titanApiFetchClient,
    apiProgressBarFetchClient,
    deApiClient,
    contentApiFetchClient,
  } = createApiClients(false);

  const initAppOptions = {
    titanApiFetch: titanApiFetchClient,
    apiProgressBarFetch: apiProgressBarFetchClient,
    deApi: deApiClient,
    contentApiFetch: addRateLimiting(contentApiFetchClient), // add a rate limiter to the content api
    domains: getDomains(),
    env: getEnv(),
    region: getRegion(),
  };

  initialize(initAppOptions);
}

run();
